// Add your custom JS here.

import counterUp from 'counterup2';

// ===== Scroll to Top ====
	(function($) {
	$(window).scroll(function() {
		if ($(this).scrollTop() >= 50) {        // If page is scrolled more than 50px
			$('#return-to-top').fadeIn(200);    // Fade in the arrow
		} else {
			$('#return-to-top').fadeOut(200);   // Else fade out the arrow
		}
	});
	$('#return-to-top').click(function() {      // When arrow is clicked
		$('body,html').animate({
			scrollTop : 0                       // Scroll to top of body
		}, 500);
	});
	})(jQuery);

//Number 
(function ($) {
  'use strict';
  $(document).ready(function () {
    // call newly created function
    setAnimation();
  });

  // add scroll event to check for animation on scroll
  $(document).scroll(function () {
    // call newly created function
    setAnimation();
  });

  // Create new function which will trigger your animation
  function setAnimation() {
    // add additional class pending to your .counter-value element to check whether animation is pending or not
    // retrieve only pending elements and loop over it
    $('.count.pending').each(function () {
      // check if element is in view and visible
      var isElementInView = Utils.isElementInView($(this), false);
      if (isElementInView) {
        // if visible then remove class pending so it won't animate multiple times
        $(this).removeClass('pending');
        // initialize animation
        const el = document.querySelectorAll('.count');
        el.forEach(function (el) {
          counterUp(el, {
            duration: 1000,
            delay: 16,
          })
        });
      }
    });
  }

  function Utils() {
  }

  Utils.prototype = {
    constructor: Utils,
    isElementInView: function (element, fullyInView) {
      var pageTop = $(window).scrollTop();
      var pageBottom = pageTop + $(window).height();
      var elementTop = $(element).offset().top;
      var elementBottom = elementTop + $(element).height();

      if (fullyInView === true) {
        return ((pageTop < elementTop) && (pageBottom > elementBottom));
      } else {
        return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
      }
    }
  };

  var Utils = new Utils();
})(jQuery);

